import { Card, Typography, Row, Col, Button, Form, Image, Layout } from "antd";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/donorDetails/actions";
const { Title, Text } = Typography;
const { Header } = Layout;

export default function PaymentSuccess() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { paymentId, amount, currentDate, from } = location.state || {};
  const typeOfUser =
    sessionStorage.getItem("typeOfUser") || localStorage.getItem("typeOfUser");

  const handleContinue = () => {
    dispatch(actions.resetDonorPersonalDetails());
    navigate("/dashboard/myDonations");
  };

  if (!paymentId) {
    return (
      <div>
        <p>Payment Information is not available</p>
      </div>
    );
  }

  return (
    <div className="responsive-container">
      <Card className="premium-card" style={{ maxWidth: "600px" }}>
        <div className="form-header">
          <div style={{
            width: "80px",
            height: "80px",
            background: "#4caf50",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto 24px",
            boxShadow: "0 8px 20px rgba(76, 175, 80, 0.3)"
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <Typography.Title level={2} style={{ margin: 0, color: "var(--text-main)" }}>
            Payment Successful!
          </Typography.Title>
          <Typography.Text type="secondary">
            Thank you for your generous contribution to SRNCF
          </Typography.Text>
        </div>

        <div style={{ background: "rgba(0,0,0,0.02)", borderRadius: "12px", padding: "24px", marginBottom: "32px" }}>
          <Row gutter={[16, 16]}>
            <Col span={10}>
              <Text strong style={{ color: "var(--text-muted)" }}>Transaction ID</Text>
            </Col>
            <Col span={14}>
              <Text style={{ fontFamily: "monospace", fontSize: "14px" }}>{paymentId}</Text>
            </Col>

            <Col span={10}>
              <Text strong style={{ color: "var(--text-muted)" }}>Amount Paid</Text>
            </Col>
            <Col span={14}>
              <Text strong style={{ fontSize: "18px", color: "var(--primary-color)" }}>₹ {amount}</Text>
            </Col>

            <Col span={10}>
              <Text strong style={{ color: "var(--text-muted)" }}>Date</Text>
            </Col>
            <Col span={14}>
              <Text>{currentDate}</Text>
            </Col>
          </Row>
        </div>

        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "16px" }}>
          <Button
            type="primary"
            className="premium-button"
            onClick={handleContinue}
          >
            View My Donations
          </Button>

          <a
            href="https://sriramanavami.com/"
            className="premium-link"
            style={{
              color: "var(--primary-color)",
              fontWeight: 600,
              fontSize: "15px"
            }}
          >
            Back to Festival Homepage
          </a>
        </div>
      </Card>
    </div>
  );
}
